import { useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import { vehicles } from "@/mocks/vehicles";

export default function VehicleDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const vehicle = vehicles.find((v) => v.id === id) || vehicles[0];
  const [days, setDays] = useState(3);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-20 max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
          <Link to="/" className="hover:text-orange-500 cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link to="/busca" className="hover:text-orange-500 cursor-pointer">Veículos</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-gray-900 font-medium">{vehicle.name}</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div>
            <div className="rounded-2xl overflow-hidden bg-gray-50 h-72 md:h-96">
              <img src={vehicle.image} alt={vehicle.name} className="w-full h-full object-cover object-top" />
            </div>
            <div className="grid grid-cols-3 gap-3 mt-3">
              {[0,1,2].map((i) => (
                <div key={i} className="rounded-xl overflow-hidden h-20 bg-gray-50 cursor-pointer border-2 border-transparent hover:border-orange-400 transition-all">
                  <img src={vehicle.image} alt="" className="w-full h-full object-cover object-top" />
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-start justify-between mb-2">
              <div>
                <span className="text-orange-500 text-sm font-semibold">{vehicle.category}</span>
                <h1 className="text-3xl font-extrabold text-gray-900 mt-1">{vehicle.name}</h1>
              </div>
              {vehicle.discount > 0 && (
                <span className="bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full">-{vehicle.discount}%</span>
              )}
            </div>

            <div className="flex items-center gap-2 mb-5">
              <div className="flex items-center gap-1">
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-fill text-yellow-400 text-sm"></i>
                <i className="ri-star-half-fill text-yellow-400 text-sm"></i>
              </div>
              <span className="text-sm text-gray-500">{vehicle.rating} ({vehicle.reviews} avaliações)</span>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
              {[
                { icon: "ri-user-line", label: `${vehicle.seats} lugares` },
                { icon: "ri-door-line", label: `${vehicle.doors} portas` },
                { icon: "ri-settings-3-line", label: vehicle.transmission },
                { icon: "ri-gas-station-line", label: vehicle.fuel },
              ].map((spec) => (
                <div key={spec.label} className="bg-gray-50 rounded-xl p-3 text-center">
                  <div className="w-6 h-6 flex items-center justify-center mx-auto mb-1">
                    <i className={`${spec.icon} text-orange-500 text-lg`}></i>
                  </div>
                  <span className="text-xs text-gray-600 font-medium">{spec.label}</span>
                </div>
              ))}
            </div>

            <p className="text-gray-600 text-sm leading-relaxed mb-6">{vehicle.description}</p>

            {/* Uber Promo */}
            <div className="bg-black rounded-2xl p-5 mb-4 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -translate-y-8 translate-x-8"></div>
              <div className="flex items-center gap-2 mb-3">
                <span className="bg-white text-black text-xs font-extrabold px-2.5 py-1 rounded-full tracking-wide">UBER</span>
                <span className="bg-green-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">30% OFF</span>
                <span className="text-white/60 text-xs">Cobrança mensal</span>
              </div>
              <div className="flex items-end justify-between">
                <div>
                  <span className="text-white/50 text-xs line-through block">R$ {vehicle.monthlyPrice?.toLocaleString("pt-BR")}/mês</span>
                  <div className="text-white text-3xl font-extrabold">
                    R$ {vehicle.uberMonthlyPrice?.toLocaleString("pt-BR")}
                    <span className="text-base font-normal text-white/60">/mês</span>
                  </div>
                </div>
                <span className="text-white/70 text-xs text-right leading-tight">Preço exclusivo<br />para motoristas Uber</span>
              </div>
            </div>

            <div className="bg-orange-50 rounded-2xl p-5 mb-6">
              <div className="flex items-center justify-between mb-3">
                <span className="text-sm font-semibold text-gray-700">Número de dias</span>
                <div className="flex items-center gap-3">
                  <button onClick={() => setDays(Math.max(1, days - 1))} className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-gray-200 hover:border-orange-400 cursor-pointer">
                    <i className="ri-subtract-line text-sm"></i>
                  </button>
                  <span className="font-bold text-gray-900 w-6 text-center">{days}</span>
                  <button onClick={() => setDays(days + 1)} className="w-8 h-8 flex items-center justify-center rounded-full bg-white border border-gray-200 hover:border-orange-400 cursor-pointer">
                    <i className="ri-add-line text-sm"></i>
                  </button>
                </div>
              </div>
              <div className="flex items-end justify-between">
                <div>
                  <span className="text-xs text-gray-500">R$ {vehicle.price}/dia &times; {days} dias</span>
                  <div className="text-2xl font-extrabold text-orange-500">R$ {vehicle.price * days}</div>
                </div>
                <span className="text-xs text-gray-400 bg-white px-3 py-1 rounded-full">Sem entrada</span>
              </div>
            </div>

            {vehicle.available ? (
              <a
                href={`https://wa.me/5519987386173?text=${encodeURIComponent(`Olá! Tenho interesse em reservar o ${vehicle.name} por ${days} dia(s). Valor total: R$ ${vehicle.price * days}. Poderia me passar mais informações?`)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-4 rounded-xl font-bold text-base transition-all whitespace-nowrap bg-green-500 hover:bg-green-600 text-white cursor-pointer flex items-center justify-center gap-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </div>
                Reservar via WhatsApp
              </a>
            ) : (
              <button
                disabled
                className="w-full py-4 rounded-xl font-bold text-base bg-gray-200 text-gray-400 cursor-not-allowed whitespace-nowrap"
              >
                Veículo Indisponível
              </button>
            )}
            <p className="text-center text-xs text-gray-400 mt-2">Atendimento direto pelo WhatsApp da loja</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
